import React, { useEffect } from 'react'
import { Container, ToastBox, ToastText, ToastClose } from './style'
import { MdClose } from "react-icons/md";


export interface ToastData {
  id: number
  message: string
}

interface ToastItemProps {
  toast: ToastData
  onClose: (id: number) => void
}

const ToastItem: React.FC<ToastItemProps> = ({ toast, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(toast.id), 5000)
    return () => clearTimeout(timer)
  }, [toast.id, onClose])

  return (
    <ToastBox>
      <ToastText>{toast.message}</ToastText>
      <ToastClose onClick={() => onClose(toast.id)}>
        <MdClose />
      </ToastClose>
    </ToastBox>
  )
}

interface ToastContainerProps {
  toasts: ToastData[]
  onClose: (id: number) => void
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onClose }) => {
  if (!toasts.length) return null
  return (
    <Container>
      {toasts.map(t => (
        <ToastItem key={t.id} toast={t} onClose={onClose} />
      ))}
    </Container>
  )
}

export default ToastContainer

let nextId = 1

export function useToast() {
  const [toasts, setToasts] = React.useState<ToastData[]>([])

  const addToast = React.useCallback((message: string) => {
    const id = nextId++
    setToasts(prev => [...prev, { id, message }])
  }, [])

  const removeToast = React.useCallback((id: number) => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  return { toasts, addToast, removeToast }
}